const fixes =
    [
        {
            name: "Apple___Apple_scab",
            fixes: ['Choose resistant varieties when possible.', 'Rake under trees and destroy infected leaves to reduce the number of fungal spores available to start the disease cycle over again next spring.  ', 'Water in the evening or early morning hours (avoid overhead irrigation) to give the leaves time to dry out before infection can occur.']
        },
        {
            name: "Apple___Black_rot",
            fixes: ['Prune out dead or diseased branches.', 'Pick all dried and shriveled fruits remaining on the trees.', 'Remove infected plant material from the area.']
        },
        {
            name: "Apple___Cedar_apple_rust",
            fixes: ['Choose resistant cultivars when available.', 'Rake up and dispose of fallen leaves and other debris from under trees.', 'Remove galls from infected junipers. In some cases, juniper plants should be removed entirely.']
        },
        {
            name: "Cherry___Powdery_mildew",
            fixes: ['fungicides', 'use of resistant varieties']
        },
        {
            name: "Corn___Cercospora_leaf_spot Gray_leaf_spot",
            fixes: [' resistant corn hybrids', 'conventional tillage', ' crop rotation']
        },
        {
            name: "Corn___Common_rust",
            fixes: ['Genetic Resistance', 'Scout corn to detect common rust early.', 'Disease is wind-borne and does not overwinter in crop residue; therefore, rotation and tillage are not effective for reducing disease severity.']
        },
        {
            name: "Corn___Northern_Leaf_Blight",
            fixes: ['resistant hybrids', 'Crop rotation and tillage practices']
        },
        {
            name: "Grape___Black_rot",
            fixes: ['Remove or burn infected prunings and mummified berries', 'standard fungicides spray schedule for disease control.']
        },
        {
            name: "Grape___Esca_(Black_Measles)",
            fixes: ['delayed pruning', 'double pruning', 'applications of pruning-wound protectants']
        },
        {
            name: "Grape___Leaf_blight_(Isariopsis_Leaf_Spot)",
            fixes: ['Plant less susceptible cultivars', 'application of Bordeaux mixture']
        },
        {
            name: "Peach___Bacterial_spot",
            fixes: ['cultivars with better bacterial spot resistance', 'Bactericides']
        },
        {
            name: "Pepper,_bell___Bacterial_spot",
            fixes: ['Using resistant varieties', 'Foliage treatment', 'Seed treatments']
        },
        {
            name: "Potato___Early_blight",
            fixes: ['Avoid nitrogen and phosphorus deficiency.', 'Rotate foliar fungicides', 'Time irrigation to minimize leaf wetness duration during cloudy weather and allow sufficient time for leaves to dry prior to nightfall.']
        },
        {
            name: "Potato___Late_blight",
            fixes: ['Plant resistant cultivars when available.', 'Remove volunteers from the garden prior to planting and space plants far enough apart to allow for plenty of air circulation.']
        },
        {
            name: "Orange___Haunglongbing_(Citrus_greening)",
            fixes: ['There is no cure for citrus greening.You may be able to prevent citrus greening by erecting a screen house around known, disease-free citrus trees', 'but psyllids are small, often no more than 1/8 inch (3 mm.) long, so your screen must be tightly woven.', 'Insecticides can be highly toxic to the bees that pollinate citrus, but if you live in one of the many citrus greening quarantine zones', 'it may be useful to treat your citrus tree’s leaves with chlorantraniliprole, spinetoram, dimethoate, or formetanate.']
        },
        {
            name: "Strawberry___Leaf_scorch",
            fixes: [' proper garden sanitation', 'removal of infected garden debris from the strawberry patch', 'frequent establishment of new strawberry transplants.']
        },
        {
            name: "Tomato___Bacterial_spot",
            fixes: ['Cultural practices', 'preventive sprays of copper']
        },
        {
            name: "Tomato___Early_blight",
            fixes: ['Prune or stake plants to improve air circulation and reduce fungal problems.', 'Make sure to disinfect your pruning shears (one part bleach to 4 parts water) after each cut.']
        },
        {
            name: "Tomato___Late_blight",
            fixes: ['resistant varieties', 'Remove or bury plants at the end of the season. Manage cull piles so culls break down over winter']
        },
        {
            name: "Tomato___Leaf_Mold",
            fixes: ['Scout for tomato leaf mold during periods of high humidity', 'Use drip irrigation and avoid watering foliage.', '']
        },
        {
            name: "Tomato___Septoria_leaf_spot",
            fixes: ['Removing infected leaves', 'Consider organic fungicide options', 'Consider chemical fungicides']
        },
        {
            name: "Tomato___Spider_mites Two-spotted_spider_mite",
            fixes: ['spider mites are rapid breeders, hence it is essential to control increasing populations ', ' Bifenazate']
        },
        {
            name: "Tomato___Target_Spot",
            fixes: ['improving airflow through the canopy', 'avoiding over-fertilizing with nitrogen']
        },
        {
            name: "Tomato___Tomato_Yellow_Leaf_Curl_Virus",
            fixes: ['covered by a clear or black plastic bag and tied at the stem at soil line.', 'If symptomatic plants have no obvious whiteflies on the lower leaf surface, these plants can be cut from the garden and BURIED in the compost.']
        },
        {
            name: "Tomato___Tomato_mosaic_virus",
            fixes: ['Avoid sprinkler irrigation when fruit is ripening', 'rotate crops with other non-solanaceous plants']
        }


    ]

export default fixes